import React, { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CATEGORIES } from '../data/mock';
import { useProducts } from '../hooks/useProducts';
import ProductCard from '../components/site/ProductCard';

export default function ShopPage() {
  const [params, setParams] = useSearchParams();
  const gender = params.get('gender') || '';
  const category = params.get('category') || '';
  const q = (params.get('q') || '').toLowerCase();
  const { products, loading, source } = useProducts();

  const items = useMemo(() => products.filter((p) =>
    (!gender || p.gender === gender || gender === 'unisex') &&
    (!category || p.category === category) &&
    (!q || p.title.toLowerCase().includes(q) || (p.tagline || '').toLowerCase().includes(q))
  ), [products, gender, category, q]);

  const setParam = (k, v) => { const n = new URLSearchParams(params); if (!v) n.delete(k); else n.set(k, v); setParams(n); };
  const title = gender ? (gender === 'men' ? 'Men' : gender === 'women' ? 'Women' : 'Unisex') : 'Shop All';

  return (
    <div className="fade-in">
      <section className="bg-champagne">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <p className="eyebrow text-espresso/60">Collection</p>
          <h1 className="mt-2 font-display text-5xl md:text-6xl">{title}</h1>
          <p className="mt-3 max-w-xl text-espresso/70">Carefully edited essentials across skincare, grooming, jewelry and self-care.</p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-5 py-10 lg:px-8">
        <div className="flex flex-wrap items-center gap-3">
          <span className="eyebrow text-espresso/60">Filter</span>
          <button onClick={() => setParam('category', '')} className={`eyebrow border px-3 py-1.5 ${!category ? 'border-espresso bg-espresso text-ivory' : 'border-stone-warm text-espresso hover:border-gold'}`}>All</button>
          {Object.entries(CATEGORIES).map(([k, c]) => (
            <button key={k} onClick={() => setParam('category', k)} className={`eyebrow border px-3 py-1.5 ${category === k ? 'border-espresso bg-espresso text-ivory' : 'border-stone-warm text-espresso hover:border-gold'}`}>{c.label}</button>
          ))}
          <div className="ml-auto flex items-center gap-2">
            {['men', 'women', 'unisex'].map((g) => (
              <button key={g} onClick={() => setParam('gender', gender === g ? '' : g)} className={`eyebrow border px-3 py-1.5 capitalize ${gender === g ? 'border-gold bg-gold text-espresso' : 'border-stone-warm text-espresso hover:border-gold'}`}>{g}</button>
            ))}
          </div>
        </div>
        {source === 'mock' && !loading && (
          <p className="mt-4 text-xs text-espresso/50">Showing preview products. Add real products in Shopify Admin and they will appear here automatically.</p>
        )}
        {loading ? (
          <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {[...Array(8)].map((_, i) => <div key={i} className="aspect-[4/5] animate-pulse bg-champagne" />)}
          </div>
        ) : items.length === 0 ? (
          <div className="py-20 text-center">
            <p className="font-display text-2xl">No products found.</p>
            <Link to="/shop" className="mt-6 btn btn-dark inline-flex">Reset filters</Link>
          </div>
        ) : (
          <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {items.map((p) => <ProductCard key={p.id} p={p} />)}
          </div>
        )}
      </section>
    </div>
  );
}
